import { DialogContentParams } from './types';

export const getOneYearFromNow = () => Date.now() + 365 * 24 * 60 * 60 * 1000;

export const getDialogContent = ({
  view,
  i18n,
  companyName,
}: DialogContentParams) => {
  if (view?.isStart) {
    return {
      title: i18n['loginModal.stayInCompliance.label'],
      description: (i18n['loginModal.verifyEmployment.text'] || '').replace(
        '{{companyName}}',
        companyName || '',
      ),
    };
  }

  if (view?.isConfirmation) {
    return {
      title: i18n['global.thankYou.label'],
      description: i18n['loginModal.rentalEmploymentCheckAlert.text'] || '',
    };
  }

  if (view?.isDeclined) {
    return {
      title: i18n['global.thanksForLettingUsKnow.label'],
      description: i18n['loginModal.addNewDiscountCode.text'] || '',
    };
  }

  return { title: '', description: '' };
};
